import { Controller } from '@hotwired/stimulus'

/*
  Custom progress or Rails progress ?
  let xhr = new XMLHttpRequest();
  xhr.open("POST", url);
  xhr.upload.addEventListener("progress", ({loaded, total}) =>{})
*/
export default class FileUploaderController extends Controller {
  static targets = [ 'form', 'file', 'button' ]

  connect() {
    this.formTarget.addEventListener('turbo:submit-start', () => this.#toggleButtons(true))
    this.formTarget.addEventListener('turbo:submit-end', () => this.#toggleButtons(false))
  }

  browse() {
    this.fileTarget.click()
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  // A button with a text label gets it swapped; an icon-only one would lose its icon, so it gets an aria-label instead.
  #toggleButtons(busy) {
    const label = I18n.t('js.common.uploading')

    this.buttonTargets.forEach((button) => {
      button.toggleAttribute('disabled', busy)

      if (!button.textContent.trim()) {
        busy ? button.setAttribute('aria-label', label) : button.removeAttribute('aria-label')
      } else if (busy) {
        button.dataset.previousLabel = button.innerText
        button.innerText = label
      } else {
        button.innerText = button.dataset.previousLabel
        delete button.dataset.previousLabel
      }
    })
  }
}
